import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

const AddProjectDialog = ({ data, open, row, onClose, onSave, isEdit }) => {
    const { t } = useTranslation();
    const projects = [...new Set(data.filter(p => p.project !== undefined).map(p => p.project))];
    console.log(row);
    const [errors, setErrors] = useState({});

    const [editData, setEditData] = useState(row || {
        id: '',
        project: '',
        description: ''
    });

    useEffect(() => {
        setEditData(row || {
            id: '',
            project: '',
            description: ''
        });
    }, [row]);

    const validate = () => {
        const newErrors = {};
        const dnsRegex = /^(?!-)[A-Za-z0-9-]{1,63}(?<!-)(\.[A-Za-z0-9-]{1,63})*$/;

        const isDuplicate = projects.some(p => p === editData.project.toLowerCase());

        if (isDuplicate && !isEdit) {
            newErrors.project = 'Project already exists';
        }

        // Handle new value
        if (!dnsRegex.test(editData.project)) {
            setErrors(prev => ({
                ...prev,
                project: 'Invalid project name'
            }));
            return;
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        let { name, value } = e.target;
        // Convert to lowercase for project and subDomain fields
        if (name === 'project') {
            value = value.toLowerCase();
        }
        setEditData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSave = () => {
        if (validate()) {
            onSave(editData);
            onClose();
        }
    };
    const handleCancel = () => {
        setEditData({
            id: '',
            project: '',
            description: ''
        });
        onClose();
    };
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{isEdit ? t('editProject') : t('addProject')}</DialogTitle>
            <DialogContent>
                <TextField
                    sx={{ display: 'none' }}
                    hidden={true}
                    margin="dense"
                    name="id"
                    label={t("id")}
                    fullWidth
                    value={editData?.id || ''}
                    disabled={isEdit}
                />
                <TextField
                    margin="dense"
                    label={t("project")}
                    name="project"
                    fullWidth
                    required={true}
                    disabled={isEdit}
                    error={!!errors.project}
                    helperText={errors.project}
                    value={editData?.project || ''}
                    onChange={handleChange}
                />
                <TextField
                    margin="dense"
                    label={t("description")}
                    name="description"
                    fullWidth
                    required={false}
                    disabled={false}
                    error={!!errors.description}
                    helperText={errors.description}
                    value={editData?.description || ''}
                    onChange={handleChange}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel} color="primary">
                    {t("cancel")}
                </Button>
                <Button onClick={() => handleSave(editData)} color="primary">
                    {t("save")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddProjectDialog;